import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { QueryFeature } from '../../../config/queryClient';

interface AlternativeDetailRowItem {
  name: string;
  initialInvestmentDate: string | null;
  committedCapital: number;
  contributedCapital: number;
  totalCashDistribution: number;
  value: number;
  valuationDate: string | null;
  multiple: number;
  return: number | null;
}

interface AlternativeDetailGroupItem {
  name: string;
  committedCapital: number;
  contributedCapital: number;
  totalCashDistribution: number;
  value: number;

  rows: AlternativeDetailRowItem[];
}

interface AlternativeDetailDTO {
  groups: AlternativeDetailGroupItem[];
}

interface FetcherParams {
  clientId: string;
  date: string;
  accountId: string;
  groupId: string;
}

const fetchAlternativeDetail = async ({
  clientId,
  accountId,
  groupId,
  date,
}: FetcherParams): Promise<AlternativeDetailDTO> => {
  return authFetch(
    urlWithParams(
      '/Consumer/OrionAccountsWidgets/AlternativeDetails',
      {
        clientId,
        asOfDate: date,
        accountId: accountId || null,
        groupId: groupId || null,
      },
      { skipNulls: true },
    ),
  );
};

interface QueryParams {
  clientId: string;
  date: string;
  accountId: string;
  groupId: string;
}

export const useAlternativeDetailQuery = ({ clientId, accountId, groupId, date }: QueryParams) => {
  return useQuery(
    [
      QueryFeature.AccountPerformanceReporting,
      'AlternativeDetail',
      clientId,
      date,
      accountId,
      groupId,
    ],

    () => fetchAlternativeDetail({ clientId, date, accountId, groupId }),
  );
};
